import { taskTypeMetricAnchorSumFields } from '@erp/shared-types';
import type { MetricInputField } from './taskMetricCardViews';

type Translate = (message: string, options: { context: string }) => string;

function anchorFieldLabel(field: string, gt: Translate): string {
  switch (field) {
    case 'anchor.totalAmount':
      return gt('Sales order total', {
        context:
          'metric card field option: the total amount of the sales order a task is about',
      });
    case 'anchor.balanceDue':
      return gt('Invoice balance due', {
        context:
          'metric card field option: the balance due on the invoice a task is about',
      });
    case 'anchor.grossAmount':
      return gt('Invoice total', {
        context:
          'metric card field option: the gross amount of the invoice a task is about',
      });
    default:
      return field;
  }
}

/**
 * The linked-record amounts a sum card on this anchor type may total, as
 * money fields (`anchor.<field>`). Empty when the type has no such anchor.
 */
export function anchorMetricFieldOptions(
  anchorEntityType: string | null | undefined,
  gt: Translate,
): MetricInputField[] {
  return taskTypeMetricAnchorSumFields(anchorEntityType).map((field) => ({
    fieldName: field,
    fieldType: 'currency',
    label: anchorFieldLabel(field, gt),
  }));
}
